import get from 'lodash.get';

const getPublishableStripeKey = (rootState) =>
  get(rootState, 'config.common.stripe.publishable_key', '');

export default getPublishableStripeKey;
